import { createTRPCReact } from '@trpc/react-query';

import type { AppRouter } from '@devizy/api-types';

export const trpc = createTRPCReact<AppRouter>();
